import { TidResult } from "@merchant_api/models/tid-result";
import { Pager } from "shared-lib";

export class TidsState {
    loading = false;
    error = null;
    record: Array<TidResult> = [];
    pager = new Pager();
}
